export const jobVacancyDetailItems = [
  {
    path: '/job-vacancy',
    title: 'Daftar Pekerjaan',
  },
  {
    path: '',
    title: 'Detail Pekerjaan',
    disabled: true,
  },
]

export const stockPricelistItems = [
  {
    path: '',
    title: 'Inventaris',
    disabled: true,
  },
  {
    path: '/inventory/stock-location',
    title: 'Kelola Lokasi',
  },
  {
    path: '',
    title: 'Kelola Stok & Harga',
  },
]

export const productItems = [
  {
    path: '',
    title: 'Inventaris',
    disabled: true,
  },
  {
    path: '',
    title: 'Kelola Produk',
  },
]
